import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { useActivityHubTabDataFetch } from 'modules/customers/hooks/useActivityHubTabDataFetch';
import { CardContainer } from 'components/shared/CardContainer/CardContainer';
import { TabsContainer } from 'components/shared/TabsContainer/TabsContainer';
import {
  ActivityListFilters,
  ActivityPageTabs,
  DealActivityFilters,
  DealActivityList,
  initialFilters,
} from 'modules/dealActivity';
import { APIRequestSort, TabsOption } from 'global';
import { TabContainer } from 'pages/DealActivity/TabContainer';
import { Email, LocalPhone, TextSnippet } from '@mui/icons-material';
import { DealActivityLinkType } from '@trnsact/trnsact-shared-types';

export const CustomerDetailsActivityHubTab = () => {
  const { id: customerAccountId } = useParams<{ id: string }>();

  const parentType = DealActivityLinkType.Vo;

  const [currentTab, setCurrentTab] = useState<ActivityPageTabs>(ActivityPageTabs.ALL);

  const [sorting, setSorting] = useState<APIRequestSort<'created_date_time'>>({
    key: 'created_date_time',
    value: 'desc',
  });
  const [filters, setFilters] = useState<ActivityListFilters>(initialFilters);

  const { activityList, prevActivityList, loading } = useActivityHubTabDataFetch({
    sorting,
    filters,
    customerAccountId,
    activityType: currentTab,
  });

  const tabs: TabsOption<ActivityPageTabs>[] = [
    {
      label: 'All Activities',
      value: ActivityPageTabs.ALL,
      component: (
        <TabContainer
          tabTitle="All Activity"
          listSlot={<DealActivityList list={activityList} loading={loading} parentType={parentType} />}
          filterSlot={
            <DealActivityFilters
              type={currentTab}
              loading={loading}
              onFiltersChanged={setFilters}
              onSortingChanged={setSorting}
            />
          }
        />
      ),
    },
    {
      label: 'Email',
      iconStart: <Email />,
      value: ActivityPageTabs.EMAIL,
      component: (
        <TabContainer
          tabTitle="Email"
          listSlot={<DealActivityList list={activityList} loading={loading} parentType={parentType} />}
          filterSlot={
            <DealActivityFilters
              type={currentTab}
              loading={loading}
              onFiltersChanged={setFilters}
              onSortingChanged={setSorting}
            />
          }
        />
      ),
    },
    {
      label: 'Call',
      iconStart: <LocalPhone />,
      value: ActivityPageTabs.CALL,
      component: (
        <TabContainer
          tabTitle="Call"
          listSlot={<DealActivityList list={activityList} loading={loading} parentType={parentType} />}
          filterSlot={
            <DealActivityFilters
              type={currentTab}
              loading={loading}
              onFiltersChanged={setFilters}
              onSortingChanged={setSorting}
            />
          }
        />
      ),
    },
    {
      label: 'Notes',
      iconStart: <TextSnippet />,
      value: ActivityPageTabs.NOTE,
      component: (
        <TabContainer
          tabTitle="Notes"
          listSlot={
            <DealActivityList /* parentId={parentId} */ list={activityList} loading={loading} parentType={parentType} />
          }
          filterSlot={
            <DealActivityFilters
              type={currentTab}
              loading={loading}
              onFiltersChanged={setFilters}
              onSortingChanged={setSorting}
            />
          }
        />
      ),
    },
  ];

  return (
    <CardContainer isLoading={loading && !prevActivityList}>
      <TabsContainer<ActivityPageTabs> tabs={tabs} onTabChange={setCurrentTab} />
    </CardContainer>
  );
};
